import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import { setApiError, togglePopover } from "../../admin/app-slice";
import {AppDispatch} from "../../core/store";
import {ApiInstance} from "../../services/api";
import {formValidator} from "./validator";

const initialState = {
  entities: [],
  entity: null,
  form:{
    name: '',
    primary_phone: '',
    organization_name: '',
    email:'',
    address:'',
    city: '',
    taxpayer_number: '',
    long_term: '',
    long_term_date: '',
    long_term_number: '',
    long_term_start: ''

  },
  validationFields:{

  } as any,
  formValid: true,
}

const entity = createSlice({
  name: 'entity',
  initialState: initialState,
  reducers: {
    setEntities: (state, action: PayloadAction<any>) => {
      state.entities = action.payload
      return state
    },
    setEntity: (state, action: PayloadAction<any>) => {
      state.entity = action.payload
      return state
    },
    handleFormChange: (state, action: PayloadAction<{ key: string, value: any }>) => {
      const data = action.payload
      state.form[data.key] = data.value
      return state
    },
    resetForm: (state)=>{
      state.form = initialState.form
      return state
    },
    validateInputs: (state, action: PayloadAction<any>) => {
      if (Array.isArray(action.payload)) {
        action.payload.forEach((el => {
          state.validationFields = formValidator(state.validationFields, el)
        }))
      } else {
        state.validationFields = formValidator(state.validationFields, action.payload)
      }
      state.formValid = Object.keys(state.validationFields).every(k => state.validationFields[k] !== false);

      return state
    },
  }
});

export const {
  setEntities,
  setEntity,
  handleFormChange,
  validateInputs,
  resetForm
} = entity.actions;

export const getEntities = (filter = {}) => {
  return async (dispatch: AppDispatch, getState: any, api: ApiInstance) => {
    try {
      const res = await api.admin.get('entity', filter)
      dispatch(setEntities(res))
      return res
    } catch (e) {
      dispatch(setApiError(e))
    }
  }
}

export const createEntity = () => {
  return async (dispatch: AppDispatch, getState: any, api: ApiInstance) => {
    const entity = getState().entity

    if (entity.formValid) {
      const data = {...entity.form}
      try {
        let response: any

        await api.admin.post('entity', {...data, type: 4})
        dispatch(togglePopover('entityAddOrganization'))
        await dispatch(getEntities())
        await dispatch(clearForm())
      } catch (e) {
        console.error('failed to create entity with error:', e)
        dispatch(setApiError(e))
      }
    }
  }
};

export const updateEntity = () => {
  return async (dispatch: AppDispatch, getState: any, api: ApiInstance) => {
    const entity = getState().entity

    if (entity.formValid) {
      try {
        await api.admin.put(`entity/${entity.entity.uuid}`, entity.form)
        dispatch(togglePopover('entityAddOrganization'))
        await dispatch(clearForm())
        await dispatch(setEntity(null))
        return await dispatch(getEntities())
      } catch (e) {
        console.error('failed to create entity with error:', e)
        dispatch(setApiError(e))
      }
    }
  }
};

export const selectEntity = (data) => {
  return (dispatch: AppDispatch) => {
    dispatch(setEntity(data))
  }
}

export const clearForm = () => {
  return (dispatch: AppDispatch) => dispatch(resetForm())
}

export const deleteEntity = (uuid: string) => {
  return async (dispatch: AppDispatch, getState: any, api: ApiInstance) => {
    try {
      return await api.admin.delete(`/entity/${uuid}`)
    } catch (e) {
      dispatch(setApiError(e))
    }
  }
}

export const formFields = Object.keys(initialState.form)

export default entity.reducer;
